import { Login } from '@unistocks/features/authentication/login/login';
import { t } from '@unistocks/localization';
import Head from 'expo-router/head';

export default function LoginScreen() {
  return (
    <>
      <Head>
        <title>{`${t('AbpUi::Login')} | Unistocks`}</title>
      </Head>
      <Login />
    </>
  );
}
